module.exports = __webpack_public_path__ + "static/Pyar-Karu-Shelly-Reddy-4d9a71b8b5c3f38c4fad6e80f3354c73.jpg";